import api from '../index'

export default {
  IsOperable(operateId, userid) {
    return api.post('/GetBtnAuth/' + operateId + '/' + userid)
  }
}